<h2 class="dsd-t-4" tabindex="-1">{{ 'caad.valider.telephone.titre' | translate }}</h2>
<p [ngClass]="{ 'dsd-mb-0': !getTelephoneSecondaire() && !getTelephoneEmployeur() }">
  <span class="libelle">{{ 'caad.valider.telephone.libelle.numerotelephoneprincipal' | translate }}&nbsp;</span>
  <span class="valeur">{{ getTelephonePrincipal()?.numeroTelephone }}</span>
</p>

<p *ngIf="getTelephoneSecondaire()" [ngClass]="{ 'dsd-mb-0': !getTelephoneEmployeur() }">
  <span class="libelle">{{ 'caad.valider.telephone.libelle.numerotelephonesecondaire' | translate }}&nbsp;</span>
  <span class="valeur">{{ getTelephoneSecondaire()?.numeroTelephone }}</span>
</p>

<div *ngIf="getTelephoneEmployeur()" class="dsd-d-flex dsd-flex-wrap">
  <p class="dsd-mb-0 dsd-mr-md">
    <span class="libelle">{{ 'caad.valider.telephone.libelle.numerotelephoneemployeur' | translate }}&nbsp;</span>
    <span class="valeur">{{ getTelephoneEmployeur().numeroTelephone }}</span>
  </p>

  <div *ngIf="getTelephoneEmployeur().numeroPoste">
    <p class="dsd-mb-0">
      <span class="libelle"> {{ 'caad.valider.telephone.libelle.postetelephoneemployeur' | translate }}&nbsp;</span>
      <span class="valeur">{{ getTelephoneEmployeur().numeroPoste }}</span>
    </p>
  </div>
</div>
